export default function ErrorDescription({ isTopFull, description }) {
  const classes = `absolute text-[12px] mt-[8px] text-negative-500 font-[300] ${isTopFull && " top-full"}`;
  return <p className={classes}>{description}</p>;
}
